/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's copyrighted materials, please contact us at
 * contact@k4d.com.br. "Knowledge for Decisions (K4D)" and the slogan "Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

/**
 * Updates URL with step ID.
 * 
 * @param {Function} setSearchParams - Search params setter
 * @param {string} stepParamName - Step parameter name
 * @param {string} stepId - Step ID
 * @returns {void}
 */
export function updateUrlWithStep(
  setSearchParams: (updater: (prev: URLSearchParams) => URLSearchParams, options?: { replace?: boolean }) => void,
  stepParamName: string,
  stepId: string,
  replace = true
): void {
  setSearchParams((prev) => {
    const next = new URLSearchParams(prev);
    next.set(stepParamName, stepId);
    return next;
  }, { replace });
}

/**
 * Gets step from URL.
 * 
 * @param {URLSearchParams} searchParams - Search params
 * @param {string} stepParamName - Step parameter name
 * @returns {string | null} Step ID or null
 */
export function getStepFromUrl(searchParams: URLSearchParams, stepParamName: string): string | null {
  return searchParams.get(stepParamName);
}

/**
 * Checks if URL step differs from current step.
 * 
 * @param {string | null} urlStep - Step from URL
 * @param {string} currentStepId - Current step ID
 * @returns {boolean} True if different
 */
export function isUrlStepDifferent(urlStep: string | null, currentStepId: string): boolean {
  return !!currentStepId && urlStep !== currentStepId;
}
